import { envIsProduction } from "common/common";

export function wsUrlGet(): string {
  let url = "";
  if (!envIsProduction()) {
    url = "ws://localhost:3002";
  } else {
    url = "wss://wsn.tehtest.emlearn.info/ws";
  }
  return url;
}
